<template>
  <form @submit.prevent="onsubmit">
    <va-input
      v-model="login"
      type="text"
      :label="$t('auth.login')"
      :error="!!loginErrors.length"
      :error-messages="loginErrors"
      class="login"
    />

    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
      class="login"
    />
    <div class="d-flex justify--center mt-3">
      <va-button type="submit" color="danger">{{ $t("auth.login") }}</va-button>
    </div>
  </form>
</template>

<script>
import { http } from "@/services/config";
import { showError } from '@/global'

export default {
  name: "login",
  data() {
    return {
      login: "",
      password: "",
      keepLoggedIn: false,
      loginErrors: [],
      passwordErrors: [],
    }
  },

  computed: {
    formReady() {
      return !this.loginErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit() {
      this.loginErrors = this.login ? [] : ["login é obrigatório."]
      this.passwordErrors = this.password ? [] : ["Password é obrigatório."]
      if (!this.formReady) {
        return
      }
      http.post("/login", {
        login: this.login,
        password: this.password
      }).then(response => {

        this.$themes.primary = response.data.color_primary
        this.$themes.secondary = response.data.color_secondary
        this.$themes.info = response.data.color_secondary

        this.$store.commit('login', response.data)
      }).catch(e => {
        showError(e)
      });
    },
  }
};
</script>

<style lang="scss">
.my-0 {
  width: 150px;
  background: #CB022A !important;
}
</style>
